import React from 'react'

type ThProps = React.ThHTMLAttributes<HTMLTableCellElement>

export function Th(props: ThProps) {
    return (
        <th style={{border: '1px solid black'}} {...props} />
    )
}
